import React from "react";
import Navbar from "./Navbar";
import { OnGoingContext } from "./ProjectContext/OnGoingContext";
import { FullStackContext } from "./ProjectContext/FullStackContext";
import { UIDContext } from "./ProjectContext/UIdesignContext";
import { useContext } from "react";
import ArrowRight from "../assets/generalicons/arrow-right-yellow.png";
import { Link } from "react-router-dom";
import { Animated } from "react-animated-css";

const WorkPage = () => {
  const onGoing = useContext(OnGoingContext);
  const fullstack = useContext(FullStackContext);
  const uidesign = useContext(UIDContext);

  return (
    <React.Fragment>
      <div className="container">
        <Navbar />
        <hr></hr>
        <Animated animationIn="fadeInLeft" isVisible={true}>
          <h4 className="ml-4 mb-4">On Going Projects</h4>
          <div className="card-deck ml-1 mr-1">
            {onGoing.map((onGoing) => (
              <div
                className="card bg-dark mb-3"
                style={{ maxWidth: "18rem", height: "130px" }}
                key={onGoing.name}
              >
                <div className="card-body">
                  <h5 className="card-title">{onGoing.name}</h5>
                  <p className="card-text">
                    See more
                    <Link to={`/project/${onGoing.id}`}>
                      <img
                        src={ArrowRight}
                        alt="arrow"
                        height="15px"
                        style={{ paddingLeft: "15px" }}
                        className="arrowstrans"
                      />
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Animated>
        <hr></hr>
        <Animated animationIn="fadeInRight" isVisible={true}>
          <h4 className="ml-4 mb-4">Full Stack Projects</h4>
          <div className="card-deck ml-1 mr-1">
            {fullstack.map((fullstack) => (
              <div
                className="card bg-dark mb-3"
                style={{ maxWidth: "18rem", height: "130px" }}
                key={fullstack.name}
              >
                <div className="card-body">
                  <h5 className="card-title">{fullstack.name}</h5>
                  <p className="card-text">
                    See more
                    <Link to={`/project/${fullstack.id}`}>
                      <img
                        src={ArrowRight}
                        alt="arrow"
                        height="15px"
                        style={{ paddingLeft: "15px" }}
                        className="arrowstrans"
                      />
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Animated>
        <hr></hr>
        <Animated animationIn="fadeInLeft" isVisible={true}>
          <h4 className="ml-4 mb-4">UI Design Projects</h4>
          <div className="card-deck ml-1 mr-1">
            {uidesign.map((uidesign) => (
              <div
                className="card bg-dark mb-3"
                style={{ maxWidth: "18rem", height: "130px" }}
                key={uidesign.name}
              >
                <div className="card-body">
                  <h5 className="card-title">{uidesign.name}</h5>
                  <p className="card-text">
                    See more
                    <Link to={`/project/${uidesign.id}`}>
                      <img
                        src={ArrowRight}
                        alt="arrow"
                        height="15px"
                        style={{ paddingLeft: "15px" }}
                        className="arrowstrans"
                      />
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Animated>
      </div>
    </React.Fragment>
  );
};

export default WorkPage;
